module.exports = __webpack_public_path__ + "img/legacy-button-example.165a49e.png";